import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { injectIntl } from "react-intl";

import ArchiveHeader from "../../../components/ArchiveHeader";
import FormSpeaker from './speaker-form';

const SpeakerForm = ({  intl, match, history, locale, setLocale }) => {
  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="add.edit.speaker" back backLink="/speakers" />
      <div className="pad-2rem">
        <Container fluid>
          <Row>
            <Col>
              <FormSpeaker history={history} match={match} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default injectIntl(SpeakerForm);
